import { WheelTypes } from './wheelTypes';

export const candiesArr = [
  { candy: 'Bonus', id: 'CJ60REe4pfb28zPVPTzdY', index: 1, isBonus: true },
  { candy: 'Green', id: 'DY1wee4Xl8kY5hkS34LEE', index: 2 },
  { candy: 'Pink', id: '_uPV2YQeo-sUNtAtJFyo-', index: 3 },
  { candy: 'Yellow', id: 'Uf1sMzpXPg4NF5pZ1aaUI', index: 4 },
  { candy: 'Blue', id: 't3Wo7drja-fjqz8FlxRlA', index: 5 },
  { candy: 'Green', id: 'UVCdlOqb_oQ9ScALzLs4p', index: 6 },
  { candy: 'Pink', id: 'FqzwwLNyncBW7PUTy3j5V', index: 7 },
  { candy: 'Yellow', id: 'sOHzROETYxkEs69UFmzoc', index: 8 },
  { candy: 'Blue', id: 'EMpT9OO16rd2BDSvrVGia', index: 9 },
  { candy: 'Green', id: 'ttmee_1JHlzFfo3J-9n9C', index: 10 },
  { candy: 'Pink', id: 'W9NvwQysOWdgOSwTAOGGE', index: 11 },
  { candy: 'Yellow', id: 'ThogbRIzmUrOZsgzJxLpy', index: 12 },
  { candy: 'Blue', id: 'jK25Y7_E97VYJdTLNgNlt', index: 13 },
  { candy: 'Green', id: '0fj01wu9J08bVeTysvsO4', index: 14 },
  { candy: 'Pink', id: 'HIi1ygZtkS_q7IbK4hKmk', index: 15 },
  { candy: 'Bonus', id: '9-ZItWjsIm7sdiaNlDSxr', index: 16, isBonus: true },
  { candy: 'Yellow', id: 'orDhXbGz4NoEqgwDdGoAM', index: 17 },
  { candy: 'Blue', id: 'YZqMUMGIVfe1wDEcB-ufB', index: 18 },
  { candy: 'Green', id: 'gxt4OG-yJ8vOCzm7FB8fK', index: 19 },
  { candy: 'Pink', id: '1Odl8tIZMvMSlghGn1RfD', index: 20 },
  { candy: 'Yellow', id: 'J7nPBR13_eqnLBRWK_Dgq', index: 21 },
  { candy: 'Blue', id: 'WXwR_nY8UneleBu2sb5VA', index: 22 },
  { candy: 'Green', id: 'pfO_is_dfGDYk3hdS6LwX', index: 23 },
  { candy: 'Pink', id: 'ut_Nuav0xEMzDjjMyd6q6', index: 24 },
  { candy: 'Yellow', id: 'QBJTnI2RRy4ND1UHyGGhq', index: 25 },
  { candy: 'Blue', id: '24lRTDJmw41nG26JB9AvU', index: 26 },
  { candy: 'Green', id: 'mhtKviB8XFIQw8zES0LVi', index: 27 },
  { candy: 'Pink', id: '-JSsfwHgoYnQhdwC5o7Vw', index: 28 },
  { candy: 'Yellow', id: 'zIctPDYyA52QhH56q0OKj', index: 29 },
  { candy: 'Blue', id: 'TO6RCf8Exczd59QxS9xW_', index: 30 },
];

export const candiesArr1 = [
  { candy: 'Bonus', id: 'CJ60REe4pfb28zPVPTzdY', index: 1, isBonus: true },
  { odd: 20, id: 'DY1wee4Xl8kY5hkS34LEE', index: 2, isOdd: true },
  { odd: 15, id: '_uPV2YQeo-sUNtAtJFyo-', index: 3, isOdd: true },
  { odd: 10, id: 'Uf1sMzpXPg4NF5pZ1aaUI', index: 4, isOdd: true },
  { odd: 20, id: 't3Wo7drja-fjqz8FlxRlA', index: 5, isOdd: true },
  { odd: 15, id: 'UVCdlOqb_oQ9ScALzLs4p', index: 6, isOdd: true },
  { odd: 10, id: 'FqzwwLNyncBW7PUTy3j5V', index: 7, isOdd: true },
  { odd: 50, id: 'sOHzROETYxkEs69UFmzoc', index: 8, isOdd: true },
  { odd: 10, id: 'EMpT9OO16rd2BDSvrVGia', index: 9, isOdd: true },
  { odd: 15, id: 'ttmee_1JHlzFfo3J-9n9C', index: 10, isOdd: true },
  { candy: 'Bonus', id: 'W9NvwQysOWdgOSwTAOGGE', index: 11, isBonus: true },
  { odd: 20, id: 'ThogbRIzmUrOZsgzJxLpy', index: 12, isOdd: true },
  { odd: 15, id: 'jK25Y7_E97VYJdTLNgNlt', index: 13, isOdd: true },
  { odd: 50, id: '0fj01wu9J08bVeTysvsO4', index: 14, isOdd: true },
  { odd: 10, id: 'HIi1ygZtkS_q7IbK4hKmk', index: 15, isOdd: true },
  { odd: 30, id: '9-ZItWjsIm7sdiaNlDSxr', index: 16, isOdd: true },
  { odd: 10, id: 'orDhXbGz4NoEqgwDdGoAM', index: 17, isOdd: true },
  { odd: 25, id: 'YZqMUMGIVfe1wDEcB-ufB', index: 18, isOdd: true },
  { odd: 10, id: 'gxt4OG-yJ8vOCzm7FB8fK', index: 19, isOdd: true },
  { odd: 15, id: '1Odl8tIZMvMSlghGn1RfD', index: 20, isOdd: true },
  { candy: 'Bonus', id: 'J7nPBR13_eqnLBRWK_Dgq', index: 21, isBonus: true },
  { odd: 50, id: 'WXwR_nY8UneleBu2sb5VA', index: 22, isOdd: true },
  { odd: 10, id: 'pfO_is_dfGDYk3hdS6LwX', index: 23, isOdd: true },
  { odd: 35, id: 'ut_Nuav0xEMzDjjMyd6q6', index: 24, isOdd: true },
  { odd: 15, id: 'QBJTnI2RRy4ND1UHyGGhq', index: 25, isOdd: true },
  { odd: 20, id: '24lRTDJmw41nG26JB9AvU', index: 26, isOdd: true },
  { odd: 10, id: 'mhtKviB8XFIQw8zES0LVi', index: 27, isOdd: true },
  { odd: 20, id: '-JSsfwHgoYnQhdwC5o7Vw', index: 28, isOdd: true },
  { odd: 15, id: 'zIctPDYyA52QhH56q0OKj', index: 29, isOdd: true },
  { odd: 25, id: 'TO6RCf8Exczd59QxS9xW_', index: 30, isOdd: true },
];

export const candiesArr2 = [
  { odd: 20, id: 'CJ60REe4pfb28zPVPTzdY', index: 1, isOdd: true },
  { odd: 40, id: 'DY1wee4Xl8kY5hkS34LEE', index: 2, isOdd: true },
  { odd: 15, id: '_uPV2YQeo-sUNtAtJFyo-', index: 3, isOdd: true },
  { odd: 20, id: 'Uf1sMzpXPg4NF5pZ1aaUI', index: 4, isOdd: true },
  { odd: 50, id: 't3Wo7drja-fjqz8FlxRlA', index: 5, isOdd: true },
  { odd: 100, id: 'UVCdlOqb_oQ9ScALzLs4p', index: 6, isOdd: true },
  { odd: 30, id: 'FqzwwLNyncBW7PUTy3j5V', index: 7, isOdd: true },
  { odd: 40, id: 'sOHzROETYxkEs69UFmzoc', index: 8, isOdd: true },
  { odd: 50, id: 'EMpT9OO16rd2BDSvrVGia', index: 9, isOdd: true },
  { odd: 60, id: 'ttmee_1JHlzFfo3J-9n9C', index: 10, isOdd: true },
  { odd: 15, id: 'W9NvwQysOWdgOSwTAOGGE', index: 11, isOdd: true },
  { odd: 75, id: 'ThogbRIzmUrOZsgzJxLpy', index: 12, isOdd: true },
  { odd: 60, id: 'jK25Y7_E97VYJdTLNgNlt', index: 13, isOdd: true },
  { odd: 50, id: '0fj01wu9J08bVeTysvsO4', index: 14, isOdd: true },
  { odd: 25, id: 'HIi1ygZtkS_q7IbK4hKmk', index: 15, isOdd: true },
  { odd: 15, id: '9-ZItWjsIm7sdiaNlDSxr', index: 16, isOdd: true },
  { odd: 75, id: 'orDhXbGz4NoEqgwDdGoAM', index: 17, isOdd: true },
  { odd: 60, id: 'YZqMUMGIVfe1wDEcB-ufB', index: 18, isOdd: true },
  { odd: 15, id: 'gxt4OG-yJ8vOCzm7FB8fK', index: 19, isOdd: true },
  { odd: 75, id: '1Odl8tIZMvMSlghGn1RfD', index: 20, isOdd: true },
  { odd: 100, id: 'J7nPBR13_eqnLBRWK_Dgq', index: 21, isOdd: true },
  { odd: 20, id: 'WXwR_nY8UneleBu2sb5VA', index: 22, isOdd: true },
  { odd: 30, id: 'pfO_is_dfGDYk3hdS6LwX', index: 23, isOdd: true },
  { odd: 25, id: 'ut_Nuav0xEMzDjjMyd6q6', index: 24, isOdd: true },
  { odd: 75, id: 'QBJTnI2RRy4ND1UHyGGhq', index: 25, isOdd: true },
  { odd: 10, id: '24lRTDJmw41nG26JB9AvU', index: 26, isOdd: true },
  { odd: 40, id: 'mhtKviB8XFIQw8zES0LVi', index: 27, isOdd: true },
  { odd: 30, id: '-JSsfwHgoYnQhdwC5o7Vw', index: 28, isOdd: true },
  { odd: 15, id: 'zIctPDYyA52QhH56q0OKj', index: 29, isOdd: true },
  { odd: 40, id: 'TO6RCf8Exczd59QxS9xW_', index: 30, isOdd: true },
];

export const bonusIndexes = {
  [WheelTypes.first]: [1, 16],
  [WheelTypes.second]: [1, 11, 21],
};

export const zoomedBonusIndexes = {
  [WheelTypes.first]: [30, 1, 2, 15, 16, 17],
  [WheelTypes.second]: [30, 1, 2, 15, 16, 17, 10, 11, 12, 20, 21, 22],
};
